import SupInfiniteScroll from './directive';
import Vue from 'vue';

const install = function(Vue) {
  Vue.directive('SupInfiniteScroll', SupInfiniteScroll);
};

if (!Vue.prototype.$isServer) {
  window.SupInfiniteScroll = SupInfiniteScroll;
  Vue.use(install); // eslint-disable-line
}

SupInfiniteScroll.install = install;
export default SupInfiniteScroll;
